import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client'
import App from './web/App';
import '../src/index.css';
import './styles/styles.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'animate.css/animate.min.css';

import * as serviceWorker from './serviceWorker';
import { LoaderProvider } from './web/components/loader/LoaderContext';

const originalWarn = console.warn;
console.error = (...args) => {
  if (
    args[0].includes('Support for defaultProps will be removed') ||
    args[0].includes('should have a unique "key" prop') ||
    args[0].includes('should not be null')
  ) {
    return;
  }
  originalWarn(...args);
};

// Create root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <LoaderProvider>
    <App />
  </LoaderProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
